/**
 * Deep-link-uri în aplicație (`#/pagina?cheie=valoare&pl=<id>`) — SURSĂ UNICĂ pentru cine le
 * CONSTRUIEȘTE (emailurile din dispatcher-ul de evenimente) și cine le CITEȘTE (navigarea din
 * web la încărcare). Înainte formatul era scris de mână în ambele locuri.
 *
 * `pl` = punctul de lucru căruia îi aparține documentul. Contractele, facturile, clienții și
 * rezervările stau în baza de date a punctului de lucru; un link deschis cu sesiunea pe alt
 * punct ar căuta documentul în altă bază și n-ar găsi nimic — fără nicio explicație.
 */
export const PARAM_PUNCT_LUCRU = 'pl';
function decodeazaSigur(s) {
    try {
        return decodeURIComponent(s);
    }
    catch {
        return s;
    }
}
/**
 * Parsează hash-ul unui deep-link. NU aruncă niciodată: parsarea rulează la încărcarea
 * modulului de navigare, iar un `decodeURIComponent('%E0')` aruncat acolo (URIError) lăsa
 * aplicația pe ecran alb, la fiecare reîncărcare, cât timp hash-ul stricat rămânea în URL.
 *
 * Fiecare pereche se împarte la PRIMUL `=` (valorile pot conține `=`, ex. base64), iar o
 * pereche nedecodabilă se păstrează brută în loc să compromită tot link-ul.
 */
export function parseazaDeepLink(hash, paginiValide) {
    const m = /^#\/([a-z-]+)(?:\?(.*))?$/.exec(hash ?? '');
    if (!m || !paginiValide.includes(m[1]))
        return null;
    const params = {};
    let pl = null;
    if (m[2]) {
        for (const kv of m[2].split('&')) {
            if (!kv)
                continue;
            const i = kv.indexOf('=');
            const k = decodeazaSigur(i === -1 ? kv : kv.slice(0, i));
            const v = i === -1 ? '' : decodeazaSigur(kv.slice(i + 1));
            if (!k)
                continue;
            if (k === PARAM_PUNCT_LUCRU) {
                pl = v || null;
                continue;
            }
            params[k] = v;
        }
    }
    return { page: m[1], params, pl };
}
/** Construiește URL-ul unui deep-link (inversul lui `parseazaDeepLink`). */
export function construiesteDeepLink(appUrl, page, params, pl) {
    const perechi = Object.entries(params).map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
    if (pl)
        perechi.push(`${PARAM_PUNCT_LUCRU}=${encodeURIComponent(pl)}`);
    const baza = appUrl.replace(/\/$/, '');
    return `${baza}/#/${page}${perechi.length ? `?${perechi.join('&')}` : ''}`;
}
//# sourceMappingURL=deep-link.js.map